import {useState} from 'react'
import LetterOfInstructionForm from './LetterOfInstructionForm';
import LetterOfInstructionList from './LetterOfInstructionList';

const LetterofInstruction = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
  
  return (
    <>
      {fromIsShown ? (
          <LetterOfInstructionForm addForm={setFromIsShown} update={upData} />
        ) : (
          <LetterOfInstructionList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default LetterofInstruction